import type { paymentServicesTypes } from '@makemydeal/dr-platform-types';
import type { KeyboardEvent } from 'react';
import { createContext } from 'react';

import type { CustomFeeItem } from './types';

export type FeesFormContextProps = {
    isLease?: boolean;
    shouldTriggerValidation?: boolean;
    handleInputChange: (params: {
        index: number;
        field: 'feeAmount' | 'feeName' | 'capIndicator' | 'feeTypeId' | 'feeDescription';
        value: string | boolean | number;
        category: paymentServicesTypes.FeeCategory;
    }) => void;
    handleInputBlur: (params: {
        index: number;
        field: 'feeAmount' | 'feeTypeId' | 'feeName';
        category: paymentServicesTypes.FeeCategory;
        isValid?: boolean;
    }) => void;
    handleDelete: (params: { index: number; category: paymentServicesTypes.FeeCategory; code: number; isDelete: boolean }) => void;
    handleAddFee: (props: { category: paymentServicesTypes.FeeCategory; feeItems: CustomFeeItem[] }) => void;
    getIsIncludeInCalc: (props: { category: paymentServicesTypes.FeeCategory; includedInCalc: boolean }) => boolean;
    setDisableFeeSubmit: (value: boolean) => void;
    getCurrentlySelectedFees: () => CustomFeeItem[];
    commitFeeSoftSave: () => void;
    commitFeeSoftSaveDebounced: () => void;
    commitFeeNameToRedux: () => void;
    isOptionalDeskingMode?: boolean;
    handleSoftSaveOnEnterKey: (
        commitChanges: () => void
    ) => (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>) => void;
};

export const FeesFormContext = createContext<FeesFormContextProps | null>(null);
